import { type Storage } from '@/infra/storage'

/**
 * A {@link Storage} for JSON values.
 */
export interface ObjectStorage {
  getItem(key: string): unknown
  removeItem(key: string): void
  setItem(key: string, value: unknown): void
}

/**
 * Creates an object storage that serializes and deserializes JSON.
 */
export function createObjectStorage(
  storage: Storage,
  prefix = '',
): ObjectStorage {
  return {
    getItem(key: string) {
      const got = storage.getItem(prefix + key)
      if (!got) {
        return null
      }

      return JSON.parse(got) as unknown
    },
    setItem(key: string, value: unknown) {
      if (value === null || value === undefined) {
        return storage.removeItem(prefix + key)
      }
      storage.setItem(prefix + key, JSON.stringify(value))
    },
    removeItem(key: string) {
      storage.removeItem(prefix + key)
    },
  }
}
